import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p12 from '../assets/images/docu.jpeg';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                   <b>Get Your Favourite Documentaries with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p12} alt="" />
            </a>


          </div>




    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://thoughtmaybe.com/" className="btn btn-xl btn-light mr-4">
         Thoughtmaybe
        </a>
        <a href="http://hbo.com/" className="btn btn-xl btn-dark">
         HBO
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://pbs.org/" className="btn btn-xl btn-light mr-4">
         American Experience
        </a>
        <a href="http://topdocumentaryfilms.com/" className="btn btn-xl btn-dark">
          Top Documentary Films
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.documentarytube.com/" className="btn btn-xl btn-light mr-4">
          Documentary Tube
        </a>
        <a href="https://app.iwonder.com/collections" className="btn btn-xl btn-dark">
          iWonder
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0"></h3>
           <iframe title="New York Times Video - Embed Player" width="300" height="250" frameborder="0" scrolling="no" allowfullscreen="true" marginheight="0" marginwidth="0" id="nyt_video_player" src="https://www.nytimes.com/video/players/offsite/index.html?videoId=100000007293397"></iframe>
          <h2 className="mb-5"> Browse Smartly<i className="fa fa-film fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://history.com/" className="btn btn-xl btn-light mr-4">
        History
        </a>
        <a href="https://eco-age.com/news/animal-documentaries-you-need-watch" className="btn btn-xl btn-dark">
        Eco Age
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://documentaryheaven.com/" className="btn btn-xl btn-light mr-4">
         Documentary Heaven
        </a>
        <a href="https://www.documentarystorm.com/" className="btn btn-xl btn-dark">
         Documentary Storm
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://documentary.net/" className="btn btn-xl btn-light mr-4">
        Documentary Net
        </a>
        <a href="https://www.youtube.com/results?search_query=wildlife" className="btn btn-xl btn-dark">
         Youtube Wildlife
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5"> Get Documentaries on the Internet  in a Smart way..<i className="fa fa-film fa-spin"></i></h2>
        </div>
        
      </div>
    </section>







<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.documentary24.com/" className="btn btn-xl btn-light mr-4">
         Documentary 24
        </a>
       <a href="https://www.pbs.org/video/" className="btn btn-xl btn-dark">
         PBS
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.contv.com/browse-movie/" className="btn btn-xl btn-light mr-4">
         Contv
        </a>
       <a href="https://video.vice.com/en_us" className="btn btn-xl btn-dark">
         Video Vice
        </a>
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.science-documentaries.com/" className="btn btn-xl btn-light mr-4">
        Science Documentaries
        </a>
       <a href="http://www.documentaryguide.com/" className="btn btn-xl btn-dark">
         documentary Guide
        </a>
      </div>
    </section>




    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
